import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { delByPathId, postPrefessionals } from 'services/api';
import { normalizeProfessionalsList } from './operations';

export interface PrefessionalsState {
  professionalLists: {
    data: any,
    filterableValues: any,
    pagination: {
      total: number,
      page: number,
    },
    status: null | 'idle' | 'loading' | 'failed',
  }
}

const initialState: PrefessionalsState = {
  professionalLists: {
    data: [],
    filterableValues: {},
    pagination: {
      total: 0,
      page: 1,
    },
    status: null,
  },
};

export const postProfessionalsAsync: any | null = createAsyncThunk(
  'prefessionals/postPrefessionals',
  async (data: any) => {
    const response = await postPrefessionals(data);
    return response?.data;
  },
);

export const delByPathIdAsync: any | null = createAsyncThunk(
  'prefessionals/delByPathId',
  async (data: any) => {
    const response = await delByPathId(data.path, data.id);
    return response;
  },
);

export const professinalsSlice = createSlice({
  name: 'professionals',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postProfessionalsAsync.pending, (state) => {
        state.professionalLists.status = 'loading';
      })
      .addCase(postProfessionalsAsync.fulfilled, (state, action) => {
        state.professionalLists.data = normalizeProfessionalsList(action.payload);
        state.professionalLists.filterableValues = action.payload?.item?.filterableValues;
        state.professionalLists.pagination.total = action.payload?.item?.total;
        state.professionalLists.status = 'idle';
      })
      .addCase(postProfessionalsAsync.rejected, (state) => {
        state.professionalLists.status = 'failed';
      })
      .addCase(delByPathIdAsync.fulfilled, (state, action) => {
        state.professionalLists.data = state.professionalLists.data.filter((item: any) => item.id !== action.meta.arg.id);
      });
  },
});

export default professinalsSlice.reducer;
